import React, { useState, useEffect } from 'react';
import { withTranslation } from './ChildrenContext.js';
import PropTypes from 'prop-types';
import DropdownList from 'react-widgets/DropdownList';
import CustomModal from './Modal';
import TZ from '../utils/Timezone/Timezone';
import UserInfoActions from '../actions/UserInfoActions';
import typeOf from '../helpers/typeOf';

const Timezone = (props) => {
    const [modalIsVisible, setModalIsVisible] = useState(false);
    const [countries, setCountries] = useState(TZ.getCountries());
    const [selectedCountry, setSelectedCountry] = useState(TZ.getCurrentCountry());
    const [timeZones, setTimeZones] = useState(props.timeZones || []);
    const [selectedTimeZone, setSelectedTimeZone] = useState(props.selectedTimeZone || {});
    const [currentTimeZone, setCurrentTimeZone] = useState(props.currentTimeZone || {});
    const [loading, setLoading] = useState(props.loading || false);

    const staticNames = (props.t && props.t.timezone) || {};
    const staticNamesModal = (props.t && props.t.modal) || {};

    useEffect(() => {
        updateTimeZones();
        updateCurrentTimeZone();
    }, []);

    const updateCurrentTimeZone = () => {
        const timeZone = TZ.getCurrent();
        const data = TZ.getTimezone(timeZone);

        setSelectedTimeZone(data || {});
        setCurrentTimeZone(data || {});
    };

    const updateTimeZones = () => {
        let list = [];

        selectedCountry.timezones.map((key) => {
            list.push(TZ.getTimezone(key));
        });

        list.sort((a, b) => {
            return +a.utc.split(':')[0] - +b.utc.split(':')[0];
        });

        setTimeZones(list);
    };

    const toggleModal = () => {
        setModalIsVisible(!modalIsVisible);
    };

    const onClose = () => {
        setSelectedCountry(TZ.getCurrentCountry());
        toggleModal();
        updateCurrentTimeZone();
    };

    const onChangeCountry = (value) => {
        setSelectedCountry(value);
        setSelectedTimeZone({});
        updateTimeZones();
    };

    const onChangeTimeZone = (value) => {
        setSelectedTimeZone(value);
    };

    const onConfirm = () => {
        if (!Object.keys(selectedTimeZone).length) {
            return;
        }

        setLoading(true);
        UserInfoActions.edit({
            timezone: selectedTimeZone && selectedTimeZone.key ? selectedTimeZone.key : ''
        }).then(onResponse);
    };

    const onResponse = (data) => {
        let newState = {
            loading: false
        };

        if (typeOf.isNumeric(data) && data === 1) {
            setCurrentTimeZone(selectedTimeZone);
            setModalIsVisible(false);
            window.location.reload();
        }

        setLoading(newState.loading);
    };

    return (
        <div className="timezone">
            <a
                className="timezone__current"
                href="#!"
                onClick={toggleModal}
            >
                <i className="fa fa-clock-o timezone__current-icon" />
                <span className="timezone__current-name hidden-xs">{currentTimeZone && currentTimeZone.nameLong ? currentTimeZone.nameLong : ''}</span>
            </a>
            <CustomModal
                visible={modalIsVisible}
                onClose={onClose}
                title={staticNames.title}
                confirmName={staticNamesModal.apply}
                loading={loading}
                confirmDisabled={!Object.keys(selectedTimeZone).length}
                onConfirm={onConfirm}
            >
                <div className="form-group">
                    <DropdownList
                        className={'rw-dropdownlist-select'}
                        dataKey="name"
                        textField='name'
                        filter={'startsWith'}
                        data={countries}
                        value={selectedCountry.name}
                        onChange={onChangeCountry}
                    />
                </div>
                <div className="form-group">
                    <DropdownList
                        className={'rw-dropdownlist-select'}
                        dataKey="key"
                        textField='nameLong'
                        placeholder={staticNames.placeholderTimezone}
                        disabled={!timeZones.length}
                        data={timeZones}
                        value={selectedTimeZone && selectedTimeZone.nameLong ? selectedTimeZone.nameLong : ''}
                        onChange={onChangeTimeZone}
                    />
                </div>
            </CustomModal>
        </div>
    );
};

Timezone.propTypes = {
    timeZones: PropTypes.array,
    selectedTimeZone: PropTypes.object,
    currentTimeZone: PropTypes.object,
    loading: PropTypes.bool,
    t: PropTypes.object
};


export default withTranslation(Timezone);
